import Vue from 'vue'
import App from './App.vue'
import {BootstrapVue, IconsPlugin, TablePlugin,ProgressPlugin,DropdownPlugin } from 'bootstrap-vue'
import Toasted from 'vue-toasted';
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css";
import $ from 'jquery';
import "bootstrap/dist/js/bootstrap.min.js";
import "@/styles/scss/style.scss";
import Multiselect from 'vue-multiselect';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import { utilMixins } from './utils/utils-mixins'

import { ValidationProvider } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { extend } from 'vee-validate';
import { required, numeric, max_value, min_value, email } from 'vee-validate/dist/rules';

import Vue2Editor from 'vue2-editor';

Vue.mixin(utilMixins);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(TablePlugin);
Vue.use(ProgressPlugin);
Vue.use(DropdownPlugin);
Vue.use(Toasted);
Vue.use(VueTelInput);
Vue.use(Vue2Editor);

Vue.component('multiselect', Multiselect);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

extend('email', {
  ...email,
  message: 'L\'e-mail saisi est invalide !'
});
// Override the default message.
extend('required', {
  ...required,
  message: 'Ce champ est obligatoire !'
});

extend('numeric', {
  ...numeric,
  message: 'Ce champ est un nombre'
});

extend('max_value', {
  ...max_value,
  message: 'Désolé! Quantité en stock insuffisante'
});
extend('min_value', {
  ...min_value,
  message: 'Valeur superieur'
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  $,
  render: h => h(App)
}).$mount('#app')


